/* Copyright 2013 - 2024 Waiterio LLC */
import getUrl from '@monorepool/env/getUrl.js'
import product from './product.js'

export default function getApiUrl(params) {
  return (
    getUrl({
      product,
      service: 'api',
      ...params,
    }) + '/api/v3'
  )
}
